import React from 'react';
import PropTypes from 'prop-types';
import ChannelSoft from './ChannelSoft';
import CallCenter from './CallCenter';
import { withApi } from '@tencent/react-aio';
import { connect } from 'react-redux';
import * as ActionTypes from '@/stores/sale/actions';
import _ from 'lodash';
import MessageBox from '@/components/MessageBox';
import DialOutModal from './DialOutModal';
import QiDian from './QiDian/index';
import message from '@/utils/message';
import { Dialog } from '@tencent/spaui';
import dayjs from 'dayjs';
import Decorate from '@tencent/spaui-decorate';
import DialIn from './DialInModal/dialIn';
import IdDetailDialog from './IdDetailDialog/index';
import IdDetailDialogStore from './IdDetailDialog/store';

import TcccControlUi from './TcccControlUi/TcccControlUi';
import TcccDialInModal from './TcccDialInModal/dialIn';
import TcccDialOutModal from './TcccDialOutModal/DialOutModal';
import TcccSoft from './TcccSoft/index';
import TcccCallCenter from './TcccCallCenter/CallCenter';
import * as actions from './api';
import './callCenterDock.less';

// 使用dataurl的目的是为了接听电话能立刻播放，而不用等待音频加载时间
import { url } from './urlData';
const pageProps = window.pageProps;

function installScript(id, src) {
  return new Promise((resolve, reject) => {
    let ccScriptEl = document.getElementById(id);
    if (ccScriptEl) {
      resolve(ccScriptEl);
    } else {
      ccScriptEl = document.createElement('SCRIPT');
      ccScriptEl.id = id;
      ccScriptEl.src = src;
      ccScriptEl.defer = true;
      ccScriptEl.onload = ccScriptEl.onreadystatechange = () => {
        if (!ccScriptEl.readyState || /complete|loaded/.test(ccScriptEl.readyState)) {
          resolve();
        }
      };
      ccScriptEl.onerror = reject;
      document.body.appendChild(ccScriptEl);
    }
  });
}

const PROGRESS_STATUS_2_TYPE = {
  PROGRESS_STATUS_LEAD: 'leads',
  PROGRESS_STATUS_POTENTIAL: 'potentials',
  PROGRESS_STATUS_ORDER: 'orders',
};

function installTcccScript({ token, sdkAppId, userId, sdkUrl }) {
  return new Promise((resove, reject) => {
    const scriptDom = document.createElement('script');
    scriptDom.setAttribute('crossorigin', 'anonymous');
    scriptDom.dataset.token = token;
    scriptDom.dataset.sdkAppId = sdkAppId;
    scriptDom.dataset.userid = userId;
    scriptDom.src = sdkUrl;
    document.body.appendChild(scriptDom);
    scriptDom.addEventListener('error', reject);
    scriptDom.addEventListener('load', () => {
      resove();
    });
  });
};

class CallCenterDock extends React.Component {
  static propTypes = {
    webApi: PropTypes.object.isRequired,
    loginStatus: PropTypes.object.isRequired,
    updateCallCenter: PropTypes.func.isRequired,
  }

  state = {
    seatNumber: 0,
    showTcccControlUi: false,
    tccAgentBar: false,
    hasTcccCenter: false,
    tcccCalledInfo: {
      timeout: 0,
      sessionId: 0,
      showDialInModal: true,
    },
    tcccDialOutInfo: null,
    tcccConnectStatus: 'over',
    tcccDispalyNumberList: [],
    qdAgentBar: false,
    show: false,
    vendor: null,
    showIdDialogInfo: {},

  };

  // 呼入弹框缓存
  dialInModalList = {}

  componentDidMount() {
    const { webApi, loginStatus } = this.props;
    const { callCenter } = loginStatus;
    if (callCenter) {
      if(callCenter.startsWith('TCCC')) {
        this.setState({ tccAgentBar: true, hasTcccCenter: true });
      }else if (callCenter.startsWith('CHANNELSOFT:')) {
        this.initChannelSoft(loginStatus, webApi);
      } else if (callCenter.startsWith('QIDIAN:')) {
        this.setState({ qdAgentBar: true });
      } else if (callCenter.startsWith('NO:')) {
        console.log('放弃加载电话呼叫面板：该用户未配置呼叫中心或坐席');
      } else if (callCenter.startsWith('ERROR:')) {
        message.error(`放弃加载电话呼叫面板， 该用户的坐席有误：${callCenter.substr('ERROR:'.length)}`);
      } else {
        message.error('电话呼叫面板加载错误， 未知的呼叫中心类型');
      }
    } else {
      console.warn('放弃加载电话呼叫面板：后端未提供呼叫中心配置');
    }
  }

  initChannelSoft(loginStatus, webApi) {
    const conf = _.find(pageProps.callCenter, (cc) => cc.vendor === 'CALL_CENTER_VENDOR_CHANNELSOFT');
    if (!conf) {
      throw new Error('Unable to find callCenter for ChannelSoft.');
    }

    installScript('cc_channelSoft', loginStatus.callCenterEntryJs || conf.entryJs).then(
      () => {
        if (window.WA) {
          const vendor = new ChannelSoft(window.WA, conf.isCallTelWithExt);
          this.callCenter = new CallCenter(webApi, vendor);

          // 显示呼出的界面
          this.callCenter.onDialOut((params, resp, makeCall, leadDetail) => {
            this.setState({
              dialOutInfo: { params, resp, makeCall, leadDetail },
            });
          });

          this.callCenter.onUpdateStatus((status, event) => {
            const waEl = document.getElementById('WA');
            if (waEl) {
              waEl.className = `online_${status}`;
            }
            this.props.updateCallCenter(this.callCenter, status, event);
          });

          // 初始化呼叫中心
          this.callCenter.init(loginStatus);

          this.props.updateCallCenter(this.callCenter, false, {});

          this.callCenter.login();
        }
      },
      (error) => {
        message.error(
          '加载电话呼叫面板失败',
          <span>
            请刷新页面重试；如果反复尝试依然不行，请联系管理员
            <hr />
            呼叫中心供应商：青牛 (ChannelSoft)
            <br />
            问题脚本地址：{error.target && error.target.src}
          </span>,
        );
      },
    );
  }

  initTCCCSoft(loginStatus, webApi) {
    const conf = _.find(pageProps.callCenter, (cc) => cc.vendor === 'CALL_CENTER_VENDOR_TCCC');
    if (!conf) {
      throw new Error('Unable to find callCenter for ChannelSoft.');
    }
    const { callCenter } = loginStatus;
    const kv = JSON.parse(callCenter.slice(5));
    const { usr, cc } = kv;
    this.setState({
      tcccLoading: true,
    });
    actions.initTcccLogin().then((res) => {
      installTcccScript({
        token: res.token,
        userId: usr, // res.userId,
        sdkUrl: res.sdkUrl,
        sdkAppId: cc, // res.sdkAppId,
      }).then(() => {
        if(window.tccc) {
          window.tccc.UI.hidefloatButton();
          window.tccc.UI.hideWorkbench();
          window.tccc.on('tokenExpired', (res) => {
            message.error(`TCCC: ${res.message}`);
            this.setState({
              tcccLoading: false,
              showTcccControlUi: false,
              tccAgentBar: false,
            });
          });

          window.tccc.on('ready', () => {
            this.setState({
              tcccDispalyNumberList: res.displayNumberList || [],
            });
            // TODO : conf 这里需要拿到appid传入上报
            const vendor = new TcccSoft(window.tccc, conf.isCallTelWithExt);
            this.callCenter = new TcccCallCenter(webApi, vendor);
            // 显示呼出的界面
            this.callCenter.onDialOut((params, resp, makeCall, leadDetail) => {
              this.setState({
                tcccDialOutInfo: { params, resp, makeCall, leadDetail },
              });
            });

            this.setState({
              tcccLoading: false,
            });
            // 表示开启，并传入redux，之后可以通过tcc.xxx来调用tccc的外呼能力
            this.props.updateCallCenter(this.callCenter, true, {});
            // 初始化呼叫中心
            this.callCenter.init(loginStatus);
            this.callCenter.addReportEvent();
            this.addTcccEventListener(this.callCenter);
          });
        }
      }, (err) => {
        console.log('error,init tccc失败', err);
      });
    })
      .catch((error) => {
        message.error(
          '加载电话呼叫面板失败',
          <span>
            请刷新页面重试；如果反复尝试依然不行，请联系管理员
            <hr />
            呼叫中心供应商：TCCC
            <br />
            问题脚本地址：{error.target && error.target.src}
          </span>,
        );
      });


    this.handleClose();
    this.setState({ disabled: false });
  }

  initQD(loginStatus, webApi) {
    const conf = _.find(pageProps.callCenter, (cc) => cc.vendor === 'CALL_CENTER_VENDOR_QIDIAN');
    if (!conf) {
      throw new Error('Unable to find callCenter for ChannelSoft.');
    }

    // webApi.getJsTicket call-center/jsticket
    // webApi.getAgency agency
    // webApi.getCurrentEmployeeUser /ags/employee/current
    Promise.all([webApi.getJsTicket().ajax(), webApi.getAgency(loginStatus.agencyId).ajax(), webApi.getCurrentEmployeeUser().ajax(), installScript('qdAgentbar', loginStatus.callCenterEntryJs || conf.entryJs)])
      .then(([ticketRes, agencyInfoRes, employUserRes]) => {
        const { ticket } = ticketRes.data || {};
        const { callCenterId, seatNo, seatPreferredPhone } = employUserRes || {};
        const currentCallCenter = agencyInfoRes?.callCenterList?.find((item) => item.callCenterId === callCenterId) || {};

        const info = {
          appId: currentCallCenter.externalId,
          kfext: seatNo,
          ticket,
          seatPreferredPhone,
        };

        if (window.qd) {
          const vendor = new QiDian(window.qd, info);
          this.callCenter = new CallCenter(webApi, vendor);

          // 显示呼出的界面
          this.callCenter.onDialOut((params, resp, makeCall, leadDetail) => {
            this.setState({
              dialOutInfo: { params, resp, makeCall, leadDetail },
            });
          });

          this.callCenter.onUpdateStatus((status, event) => {
            const qdAgentbarEle = document.getElementById('qd-agentbar');
            if (qdAgentbarEle) {
              qdAgentbarEle.className = `online_${status}`;
            }
            this.props.updateCallCenter(this.callCenter, status, event);
            if (status) {
              this.handleClose();
              this.setState({ qdAgentBar: false, vendor: 'CALL_CENTER_VENDOR_QIDIAN' });
              console.log('呼叫中心初始化成功');
            }
            this.setState({ disabled: false });
          });

          this.callCenter.onDialIn(this.handleDialInInfo);
          // 初始化呼叫中心
          this.callCenter.init(loginStatus);

          this.props.updateCallCenter(this.callCenter, false, {});

          this.callCenter.login();
        }
      })
      .catch((error) => {
        message.error(
          '加载电话呼叫面板失败',
          <span>
            请刷新页面重试；如果反复尝试依然不行，请联系管理员 {error.message}
            <hr />
            呼叫中心供应商：企点
            <br />
            问题脚本地址：{loginStatus.callCenterEntryJs || conf.entryJs}
          </span>,
        );
      });
  }

  handleQdLogin = () => {
    this.setState({ show: true });
  }

  handleTcccLogin = () => {
    this.setState({ show: true, tccAgentBar: true });
  }

  handleSubmit = () => {
    const { webApi, loginStatus } = this.props;
    this.setState({ disabled: true });
    this.initQD(loginStatus, webApi);
  }


  // 添加监听事件
  addTcccEventListener = (callCenter) => {
    window.tccc.on('callOuted', () => {
      this.setState({
        tcccConnectStatus: 'connect',
      });
    });

    window.tccc.on('userAccessed', (res) => {
      console.log('呼入电话坐席接通啦', res);
      const tcccCalledInfo = this.state.tcccCalledInfo;
      tcccCalledInfo.isAnswered = true;
      this.setState({
        tcccCalledInfo,
      });
    });

    window.tccc.on('sessionEnded', (res) => {
      console.log('电话结束啦 关闭音频');
      this.setState({
        tcccConnectStatus: 'over',
      });
    });

    //  呼入后弹框，不显示交互
    window.tccc.on('callIn', (rest) => {
      // 呼入事件监听
      // 非直销呼入禁止弹屏
      this.setState({
        tcccConnectStatus: 'connect',
      });
      console.log('1、走接听呼入的逻辑');
      // 非直销呼入支持线索弹框
      const { sessionId, callerPhoneNumber, timeout, id, startCallTime, calleePhoneNumber } = rest;
      console.log('2、展示呼入组件', rest);
      //  呼入组件参数
      this.setState({
        tcccCalledInfo: {
          timeout,
          sessionId,
          Caller: `+${callerPhoneNumber.toString().slice(2)}`,
          Callee: `+${calleePhoneNumber.toString().slice(2)}`,
          CallId: id,
          switchboardNumber: `+${calleePhoneNumber.toString().slice(2)}`,
          isAnswered: false,
          CallTime: this.handleDialInTime(startCallTime / 1000),
          vendor: 'CALL_CENTER_VENDOR_TCCC',
          handleTcccDialIn: this.handleTcccDialIn,
          showDialInModal: true,
          callCenter,
        },
      });
    });

    window.tccc.on('agentStateChanged', (rest) => {
      if(rest.queueCount) {
        let total = 0;
        Array.from(Object.keys(rest.queueCount)).forEach((key) => {
          total = total + rest.queueCount[key];
        });
        this.setState({
          seatNumber: total,
        });
      }else{
        this.setState({
          seatNumber: 0,
        });
      }
    });
  };

  handleSubmitTcc =() => {
    const { webApi, loginStatus } = this.props;
    this.setState({ disabled: true, showTcccControlUi: true });
    this.handleClose();
    this.initTCCCSoft(loginStatus, webApi);
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  renderBar = () => {
    return <div onClick={this.handleQdLogin} className="qd-agent-btn"></div>;
  }

  renderTcccBar = () => {
    return <div onClick={this.handleTcccLogin} className="qd-agent-btn"></div>;
  }

  handleDialIn = () => {
    this.callCenter.handleDialIn();
  }

  handleTcccDialIn = (sessionId) => {
    const tcccCalledInfo = this.state.tcccCalledInfo;
    tcccCalledInfo.isAnswered = true;
    this.setState({
      tcccCalledInfo,
    });
    this.callCenter.vendor.agent.Call.accept({
      sessionId,
    });
    const timer = setTimeout(() => {
      this.callCenter.vendor.agent.UI.showNotificationBar();
      clearTimeout(timer);
    }, 2000);
  }

  updateDisplayNumber = (number) => {
    this.callCenter.updateDisplayNumber(number);
  }

  stopNumberFn = () => {
    this.callCenter.hungUp();
  }

   callNumberFn = (number) => {
     // 一个用来展示 交互框
     if (!number) return;

     let precheckParam = {
       mode: 'manual', // 手动触发
       isIntellectCall: false,
       calleeNumber: `+86${number}`,
       makeCall: this.callCenter.makeCall.bind(this.callCenter),
       callerNumber: null,
     };

     console.log('第一步 precheck');
     try {
       this.callCenter.handleDialOut(precheckParam).then((res) => {
         const { params, resp, dialOut, leadDetail } = res;
         // 展示弹框
         this.setState({
           tcccDialOutInfo: { params, resp, makeCall: dialOut, leadDetail },
         });
         console.log('第五步显示弹框', res, 'showTcccControlUi', this.state.showTcccControlUi, 'tccAgentBar', this.state.tccAgentBar);
         // 拨打电话
         const { grayList, dialOutRule, highSeaRule, leadHighSeaRule, leadList, potentialHighSeaMaxLimitRule, leadHighSeaMaxLimitRule } = resp;
         const { loginStatus } = this.props;
         let notMineRule;
         if (leadList && leadList.length === 1) {
         // 用户通过外呼面板拨打，且只有一条关联线索时直接拨打
           const lead = _.first(leadList);
           if (!lead.operateFlag && lead.ownerId !== loginStatus.userId && lead.visibilityScope !== 'VISIBILITY_SCOPE_PUBLIC' && lead.cleaningStatus !== 'CLEANING_STATUS_INVALID') {
           // 禁止拨打别人跟进的线索
             notMineRule = true;
             console.log('第六步，禁止拨打电话');
           }else if (!grayList && !dialOutRule && !highSeaRule && !leadHighSeaRule && !leadHighSeaMaxLimitRule && !potentialHighSeaMaxLimitRule) {
             const lead = _.first(leadList);
             const selectedId = lead.leadId;
             const showIdDialogInfo = {
               type: PROGRESS_STATUS_2_TYPE[lead.progressStatus],
               id: selectedId,
             };
             // 1、先check ，2、后打电话
             this.callCenter.checkDialOut(lead.leadId, params).then((r2) => {
               this.callCenter.makeCall(r2.phoneNumber, params, r2, { leadId: lead.leadId });
               IdDetailDialogStore.changeIdDialogInfo({ ...showIdDialogInfo });
             });
           }
         }
       });
     } catch (error) {
       console.log('error', error);
     }
   }

   render() {
     const { dialOutInfo, tcccConnectStatus, hasTcccCenter, qdAgentBar, tccAgentBar, show, tcccLoading, disabled, showTcccControlUi, tcccDialOutInfo, tcccCalledInfo, tcccDispalyNumberList, seatNumber }  = this.state;
     const { webApi, whiteList } = this.props;
     let TempoComponent = () => <div/>;
     if (qdAgentBar) {
       TempoComponent = () => (
        <React.Fragment>
          {this.renderBar()}
          <Dialog useNewUI disabled={disabled} style={{ width: 448 }} show={show} hideScrollBar={false} onClose={this.handleClose} onSubmit={this.handleSubmit} onCancel={this.handleClose} title="登录">
            点击确认登录呼叫中心
          </Dialog>
        </React.Fragment>
       );
     }

     // tccc UI
     if (tccAgentBar) {
       TempoComponent = () => (
         <React.Fragment>
           <Dialog useNewUI disabled={disabled} style={{ width: 448 }} show={show} hideScrollBar={false} onClose={this.handleClose} onSubmit={this.handleSubmitTcc} onCancel={this.handleClose} title="登录">
             点击确认登录TCCC呼叫中心
           </Dialog>
         </React.Fragment>
       );
     }

     if (dialOutInfo && dialOutInfo.resp) {
       TempoComponent = () => (
        <DialOutModal
          leadDetail={dialOutInfo.leadDetail}
          params={dialOutInfo.params}
          {...dialOutInfo.resp}
          contactPhone={dialOutInfo.params.contactPhone}
          makeCall={(id, showIdDialogInfo) => {
            dialOutInfo.makeCall(id);
            IdDetailDialogStore.changeIdDialogInfo({ ...showIdDialogInfo });
          }}
          onClose={this.handleCloseDialOutModal}
        />
       );
     }

     if (tcccDialOutInfo && tcccDialOutInfo.resp) {
       TempoComponent = () => (
        <TcccDialOutModal
          leadDetail={tcccDialOutInfo.leadDetail}
          params={tcccDialOutInfo.params}
          {...tcccDialOutInfo.resp}
          contactPhone={tcccDialOutInfo.params?.contactPhone}
          makeCall={(id, showIdDialogInfo) => {
            tcccDialOutInfo.makeCall(id);
            IdDetailDialogStore.changeIdDialogInfo({ ...showIdDialogInfo });
          }}
          onClose={this.handleCloseTcccDialOutModal}
        />
       );
     }

     return (
      <div>
        {/* 呼入线索 */}
        {
          tcccCalledInfo.showDialInModal ?  <TcccDialInModal
          handleDialIn={this.handleTcccDialIn}
          onClose={() => {}}
          Caller={tcccCalledInfo.Caller} whiteList={{ data: whiteList }} webApi={webApi} params={tcccCalledInfo}/>
            : null
        }
        {
          hasTcccCenter ?  <>
           <TcccControlUi
            updateDisplayNumber={this.updateDisplayNumber}
            displayNumberList={tcccDispalyNumberList}
            showTcccControlUi={showTcccControlUi}
            tcccConnectStatus={tcccConnectStatus}
            stopPhoneNumber={this.stopNumberFn}
            callNumberFn={this.callNumberFn}
            loading={tcccLoading}
            seatNumber={seatNumber}
            logoutTccc={() => {
              this.setState({
                showTcccControlUi: false,
              });
              this.callCenter.vendor.agent.offline();
              this.props.updateCallCenter(null, true, {});
            }}/>

            {
              !showTcccControlUi  ?  this.renderTcccBar() : null
            }
          </>  : null
        }
        <TempoComponent/>
        <IdDetailDialog/>
        <audio id="myAudio">
            <source src={url} type="audio/mpeg" />
        </audio>
      </div>
     );
   }

  handleCloseDialOutModal = () => {
    const { mode } = this.state.dialOutInfo.params;
    // 关闭 DialOutModal 对话框
    this.setState({
      dialOutInfo: undefined,
    });
    this.callCenter.setLimitQuickClickCall(false);
    // 关闭后检查是否需要弹出拨号面板，如果是手工拨出则弹出
    if (mode === 'manual') {
      this.callCenter.autoShowPanel();
    }
    const timer = setTimeout(() => {
      document?.body?.classList?.remove?.('dragging');
      clearTimeout(timer);
    });
  }

   handleCloseTcccDialOutModal = () => {
     this.setState({
       tcccDialOutInfo: undefined,
     });
   }


  handleDialInInfo = (params = {}, page = {}) => {
    // 非直销呼入禁止弹屏
    const { whiteList, loginStatus } = this.props;
    if(!_.includes(whiteList.data, loginStatus.agencyId)) return;
    // switchboardNumber(B侧总机号码)
    const { Caller, Callee, CallId, switchboardNumber, isAnswered, CallTime } = params;
    const { webApi } = this.props;
    let dialog = this.dialInModalList[Caller];
    const dialProps = {
      Caller,
      params: {
        Caller,
        Callee: switchboardNumber,
        CallId,
        isAnswered,
        vendor: this.state.vendor,
        CallTime: this.handleDialInTime(CallTime),
        _CallTime: CallTime,
      },
      whiteList,
      webApi,
      handleDialIn: this.handleDialIn,
    };
    if (dialog) {
      dialog.setProps({
        onClose: this.dialInModalDestory,
        ...dialProps,
      });
    } else {
      dialog = new Decorate(DialIn);
      this.dialInModalList[Caller] = dialog;
      dialog.setProps({
        onClose: this.dialInModalDestory,
        ...dialProps,
      });
    }
  }

  // 格式化呼入时间
  handleDialInTime = (time) => {
    if (time) {
      time = Math.floor(time * 1000);
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    }
    return dayjs().format('YYYY-MM-DD HH:mm:ss');
  }

  // 清空呼入弹框
  dialInModalDestory = (Caller) => {
    if (this.dialInModalList[Caller]) {
      this.dialInModalList[Caller] = null;
    }
  }
}

function mapStateToProps(state) {
  return {
    loginStatus: state.loginStatus,
    whiteList: state.customerProtectionWhiteList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateCallCenter: (callCenter, status, event) => dispatch({
      type: ActionTypes.CALL_CENTER_UPDATE,
      callCenter,
      status,
      event,
    }),
  };
}

export default withApi(connect(mapStateToProps, mapDispatchToProps)(CallCenterDock));

CallCenterDock.contextType = MessageBox;
